import React from 'react'

export default function SectorSelector({ sectors, selected, onChange }) {
  return (
    <div className="sector-selector">
      <label htmlFor="sector-select" className="sector-selector__label">
        <i className="fas fa-filter" /> Settore
      </label>
      <select
        id="sector-select"
        className="sector-selector__select"
        value={selected || ''}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="">Tutti i settori</option>
        {sectors.map(sector => (
          <option key={sector.id} value={sector.id}>
            {sector.name}
          </option>
        ))}
      </select>
    </div>
  )
}
